module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "iscroll",
      rawName: "v-iscroll"
    }],
    staticClass: "go-out-list"
  }, [_c('ul', {
    staticClass: "go-out-wrap"
  }, _vm._l((_vm.outList), function(item, index) {
    return _c('li', {
      staticClass: "list"
    }, [_c('div', {
      staticClass: "bor"
    }), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('span', {
      staticClass: "thing"
    }, [_vm._v(_vm._s(item.dynamic))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11acf74e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/go-out-list.vue
// module id = 172
// module chunks = 1